import React, { useState } from 'react';
import '../styles/GenericExample.css';

const selectorExamples = [
  {
    id: 'css-id-section',
    label: 'Save Profile',
    buttonProps: {
      id: 'css-id-save-btn',
      className: 'css-demo-btn',
    },
  },
  {
    id: 'css-class-section',
    label: 'Update Status',
    buttonProps: {
      id: 'css-class-action-btn',
      className: 'status-btn',
    },
  },
  {
    id: 'css-attribute-section',
    label: 'Apply Filter',
    buttonProps: {
      'data-action': 'css-attr-apply',
    },
  },
  {
    id: 'css-multi-attribute-section',
    label: 'Upgrade Plan',
    buttonProps: {
      id: 'css-multi-premium-btn',
      className: 'css-demo-btn css-demo-btn--secondary',
      type: 'button',
      'data-tier': 'css-multi-premium',
    },
  },
  {
    id: 'css-contains-section',
    label: 'Download Report',
    buttonProps: {
      id: 'css-contains-download-btn',
      className: 'btn-css-contains-download css-demo-btn',
    },
  },
  {
    id: 'css-starts-with-section',
    label: 'Reset Form',
    buttonProps: {
      id: 'css-starts-reset-btn',
      className: 'css-demo-btn css-demo-btn--secondary',
    },
  },
  {
    id: 'css-ends-with-section',
    label: 'Submit Application',
    buttonProps: {
      id: 'css-ends-submit-btn',
      className: 'css-demo-btn',
      'data-testid': 'submit-css-ends',
    },
  },
];

const GenericExample = () => {
  const [messages, setMessages] = useState({});

  const handleButtonTap = (sectionId, label) => {
    setMessages((prev) => ({
      ...prev,
      [sectionId]: `${label} button is tapped.`,
    }));
  };

  return (
    <div className="generic-page" id="generic-page">
      <div className="generic-grid">
        {selectorExamples.map((example) => (
          <section className="generic-card" id={example.id} key={example.id}>
            <div className="generic-action-row" id={`${example.id}-demo`}>
              <button
                type="button"
                {...example.buttonProps}
                onClick={() => handleButtonTap(example.id, example.label)}
              >
                {example.label}
              </button>

              <div className="generic-result" id={`${example.id}-result`}>
                {messages[example.id] ? (
                  <p className="generic-result-message" role="status">
                    {messages[example.id]}
                  </p>
                ) : (
                  <p className="generic-result-placeholder">Tap result will appear here.</p>
                )}
              </div>
            </div>
          </section>
        ))}
      </div>
    </div>
  );
};

export default GenericExample;
